import { lostStage as lost, openStage as open, wonStage as won } from './fixed-pipelines.js';
/**
 * Client Services' Account Management pipelines (Christina Saldarriaga's mapping, TS-1939), with
 * her names and order. COR Upsell, Bundle Upsell and COR Onboarding are Deal Flow pipelines and
 * Replacement is a Job Flow pipeline (one job per replacement request), none of them the default.
 * A deal or job holds a place in an extra pipeline only once deals and jobs can sit in several
 * pipelines; until then they are listed in Settings → Pipelines and hold no records.
 *
 * Seeded by `seedClientServicesPipelines` (`@crm/db`); here so the web app's mock API serves the
 * same pipelines without a copy. 🔴 The ids are fixed (`FixedPipeline`).
 */
export const CLIENT_SERVICES_PIPELINES = [
    {
        id: '43180a61-0bb7-4991-8855-1daee40f5e80',
        name: 'COR Upsell',
        appliesTo: 'deal',
        stages: [
            open('89117baf-395a-4501-90ea-963f013458c1', 'Discovery – Kick-off Call', '300'),
            open('89015fce-ceae-47e4-939d-721e6b055a66', 'Proposal', '400'),
            open('33ae813c-5f2b-40f4-a46f-0daa93792883', 'Relax Sequence – Follow up 1', '400'),
            open('887c1381-5b28-4ca3-8876-bd3e8fe4d4b0', 'Relax Sequence – Follow up 2', '500'),
            open('1bc97232-af04-42ab-92d7-cc7815e4df62', 'Relax Sequence – Follow up 3', '500'),
            open('e78f4f48-3af2-4283-a7cf-9b491da69423', 'Active – Onboarding on Leve', '600'),
            won('8aa0dc50-cb64-4bb7-ae29-b55e18a3f8de', 'Won'),
            lost('e083cd70-c1bd-401a-ad35-610b42b38a6d', 'Lost'),
        ],
    },
    {
        id: '453374d6-8a97-48c8-94d6-84558e2cdb8c',
        name: 'Bundle Upsell',
        appliesTo: 'deal',
        stages: [
            open('590c71ed-4bff-4094-b3a0-ff47bf7b576d', 'Discovery – Kick-off Call', '300'),
            open('1f7a016b-5b57-4f73-a781-26f2f0910678', 'Proposal', '400'),
            open('af31e485-5bec-46c0-af76-67e28a499fda', 'Relax Sequence – Follow up 1', '400'),
            open('8dd9c19d-a878-4e55-ba95-b78f40831ada', 'Relax Sequence – Follow up 2', '500'),
            open('23465e09-eeb2-4f79-b19a-136968163cc6', 'Relax Sequence – Follow up 3', '500'),
            open('7f0d760d-b0be-4ad9-b824-f13d8e70eb43', 'Active – Bundle Activated', '600'),
            won('e432bac7-20c1-4ea6-8d1e-a9c1dfb1da0f', 'Won'),
            lost('ec921f80-b7f4-4ac2-aab7-0f7806c89b5c', 'Lost'),
        ],
    },
    {
        id: '18c71820-e8e5-48a5-ac3b-944ebb450ecc',
        name: 'COR Onboarding',
        appliesTo: 'deal',
        stages: [
            open('5de73eb2-e9f0-4b08-92bd-7459d059d229', 'Onboarding Started', '300'),
            open('e578b662-0739-4797-975d-37fcc9c9543e', 'Client Account Confirmed', '300'),
            open('995d45b9-16f6-4257-ac18-ff01029c56ba', 'Banking Info Added', '400'),
            open('744c6eca-c8ef-48ba-bc92-52c5d0a4826b', 'Client Documents Signed', '400'),
            open('c52c31b3-b07b-42ea-9f55-911cd757f3ea', 'Talent Onboarded', '500'),
            open('80936c2f-e991-4834-bf42-feedde1abf04', 'Agreements Signed & Uploaded', '500'),
            open('d2371533-93a5-4f41-ac54-f946ff72d3aa', 'Legal Compliance Docs Completed', '500'),
            open('ddfd6a25-5278-48a5-8094-98d4a45c6a83', 'Cadana Completed', '600'),
            open('0cf08629-ea71-4cb5-a502-c8ce58389528', 'Time Doctor Set Up & Working', '600'),
            won('919b0d03-f5aa-4aae-9feb-b0c10a19b586', 'Onboarding Complete'),
            // Lost as Christina marked it: the card leaves it for the stage it was stuck on.
            lost('23765c50-4d40-485e-bdfc-b650ce16512c', 'Stalled – Needs Follow-up'),
        ],
    },
    {
        id: 'f4272242-f659-4f2c-931b-2096bcaba42a',
        name: 'Replacement',
        appliesTo: 'job',
        stages: [
            open('0f86b135-5e78-45f9-978e-bee097b76ab5', 'Replacement Requested', '300'),
            open('7123bbe3-c0ac-49fc-ae16-0e71cb6d40f0', 'Eligibility Check', '300'),
            open('2f579200-4544-4fa3-b282-8d26bd41e677', 'Replacement Meeting', '400'),
            open('ab4b489d-549c-4fd4-9c73-fe4a3bef9f97', 'Shortlist Sent', '400'),
            open('82926add-5be8-4ce2-bf5c-d35ffca0b809', 'Interviewing', '500'),
            open('73f77cee-4da2-4586-a397-a50cd45eef48', 'Candidate Selected', '500'),
            open('b68b9eac-51bd-4e65-8c7d-8c0c2d38f1d2', 'Onboarding New Talent', '600'),
            open('0d82a4ce-cf9e-4b69-8adf-42438ef85837', 'Offboard Previous Talent', '600'),
            won('a7bd9ec1-8456-4771-af11-02df267b05d4', 'Replacement Filled'),
            lost('4b16c161-9c09-4c47-9a12-adc390239b2b', 'Not Eligible – Limit Reached'),
            lost('0b4dbc24-6f6b-4401-9a40-f29ef99de68f', 'Cancelled'),
        ],
    },
];
const replacementField = (field) => ({
    required: false,
    group: 'Replacement',
    visibility: {},
    isIndexed: false,
    ...field,
});
/**
 * The fields Christina's Replacement card carries. The term belongs to the client (the project);
 * the reason and the two talents to one replacement (the job). The replacements used are
 * RecruitCRM's own `projects.replacements_used` ("Replacements Used", from the custom-field
 * import), not a field of this list.
 */
export const CLIENT_SERVICES_FIELDS = [
    replacementField({
        entity: 'projects',
        key: 'client_type',
        label: 'Client type',
        type: 'single_select',
        options: [
            { value: 'cor', label: 'COR' },
            { value: 'non_cor', label: 'Non-COR' },
        ],
        isIndexed: true,
        position: 0,
    }),
    replacementField({
        entity: 'projects',
        key: 'replacement_term_start',
        label: 'Term start date',
        type: 'date',
        position: 1,
    }),
    replacementField({
        entity: 'projects',
        key: 'replacement_term_end',
        label: 'Term end date',
        type: 'date',
        position: 2,
    }),
    replacementField({
        entity: 'jobs',
        key: 'replacement_reason',
        label: 'Reason for replacement',
        type: 'long_text',
        position: 0,
    }),
    replacementField({
        entity: 'jobs',
        key: 'replaced_talent',
        label: 'Talent being replaced',
        type: 'text',
        position: 1,
    }),
    replacementField({
        entity: 'jobs',
        key: 'new_talent_name',
        label: 'New talent name',
        type: 'text',
        position: 2,
    }),
];
//# sourceMappingURL=client-services-pipelines.js.map